import ApaleoConnect from './ApaleoConnect';

export default ApaleoConnect;
